/*
 * P Flash Sale — điều khiển khối Flash Sale (sections/p-flash-sale.liquid).
 *
 * Thời gian và mức giảm đều hỏi PPromo (đọc từ BOGOS):
 *   - đang chạy -> hiện khối, đếm ngược tới giờ đóng, tính giá sau giảm
 *   - sắp chạy  -> hiện khối, đếm ngược tới giờ mở, KHÔNG đổi giá
 *   - không có  -> ẩn cả khối
 *
 * Hết giờ tự chuyển trạng thái, không cần tải lại trang.
 */
(function () {
  'use strict';
  if (window.__pFlashSaleInit) return;
  window.__pFlashSaleInit = true;

  var LABEL_RUNNING = 'Kết thúc sau';
  var LABEL_UPCOMING = 'Bắt đầu sau';

  function P() { return window.PPromo || null; }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }
  function num(el, attr) { return Number(el.getAttribute(attr)) || 0; }
  function sections() { return document.querySelectorAll('[data-p-flash]'); }

  /* ------------------------------------------------------------------ *
   * Ghép khối với đúng đợt flash sale
   * ------------------------------------------------------------------ */

  function saleFor(section) {
    var p = P();
    if (!p) return null;

    var collId = num(section, 'data-collection-id');
    var handle = section.getAttribute('data-collection-handle') || '';

    // BOGOS chỉ đẩy discount của KHUNG GIỜ HIỆN TẠI ra storefront. Giữa hai
    // khung (vd 13:00–15:00) thì đợt đọc được lại là 08:00 NGÀY MAI — đếm
    // ngược 19 tiếng là vô nghĩa, nên chặn bằng ngưỡng "hiện sớm trước N giờ".
    var hours = parseFloat(section.getAttribute('data-upcoming-hours'));
    if (isNaN(hours) || hours <= 0) hours = 3;

    var list = p.getFlashSales({ includeUpcoming: true, upcomingWithinMs: hours * 3600000 });

    for (var i = 0; i < list.length; i++) {
      var d = list[i];
      if (collId && d.collectionIds.indexOf(collId) !== -1) return d;
      if (handle && (d.collectionHandles || []).indexOf(handle) !== -1) return d;
      if (!d.collectionIds.length && !d.productIds.length && !d.variantIds.length) return d;
    }
    return null;
  }

  /* ------------------------------------------------------------------ *
   * Số "đã bán" ước lượng — CỐ ĐỊNH theo sản phẩm + theo ngày.
   *
   * Random mỗi lần tải trang sẽ tự phản chủ: khách F5 thấy "còn 3" nhảy
   * thành "còn 8" là mất tin ngay. Hàm này cho ra cùng một số suốt cả ngày
   * với cùng một sản phẩm, sang ngày mới mới đổi.
   * ------------------------------------------------------------------ */

  function seededPercent(productId, min, max) {
    if (max < min) { var t = min; min = max; max = t; }
    var day = Math.floor(Date.now() / 86400000);
    var x = Math.sin(productId * 9301 + day * 49297) * 233280;
    var frac = x - Math.floor(x);
    return Math.round(min + frac * (max - min));
  }

  function stockInfo(section, item) {
    var qty = num(item, 'data-qty');
    var baseline = num(section, 'data-stock-baseline');
    var low = num(section, 'data-low-stock') || 10;
    var hotMin = num(section, 'data-hot-min') || 55;
    var hotMax = num(section, 'data-hot-max') || 85;
    var pid = num(item, 'data-product-id');

    if (baseline <= 0) return null;

    // Tồn kho thật -> số đã bán thật so với mốc ban đầu
    if (qty > 0) {
      var sold = Math.max(0, baseline - qty);
      var pct = Math.min(95, Math.round((sold / baseline) * 100));
      return {
        percent: Math.max(pct, 5),
        text: qty <= low ? ('Chỉ còn ' + qty + ' sản phẩm') : ('Đã bán ' + sold + ' sản phẩm')
      };
    }

    // Không theo dõi tồn kho -> mức ước lượng cố định theo ngày, quy ra số sản phẩm
    var est = seededPercent(pid, hotMin, hotMax);
    var estSold = Math.max(1, Math.round((est / 100) * baseline));
    return { percent: est, text: 'Đã bán ' + estSold + ' sản phẩm' };
  }

  /* ------------------------------------------------------------------ *
   * Giá + tiết kiệm
   * ------------------------------------------------------------------ */

  function paintItem(section, item, collIds) {
    var p = P();
    var price = num(item, 'data-price');
    var compare = num(item, 'data-compare');
    if (!price) return;

    var now = item.querySelector('[data-p-flash-now]');
    var was = item.querySelector('[data-p-flash-was]');
    var badge = item.querySelector('[data-p-flash-badge]');

    var res = p.getFlashPrice(
      price,
      num(item, 'data-variant-id'),
      num(item, 'data-product-id'),
      collIds
    );

    var finalPrice = res ? res.price : price;
    var fsSaved = res ? res.saved : 0;

    if (now) now.textContent = p.money(finalPrice);

    if (was) {
      if (compare > finalPrice) {
        was.textContent = p.money(compare);
        was.hidden = false;
      } else if (res && price > finalPrice) {
        was.textContent = p.money(price);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }

    if (badge) {
      if (fsSaved > 0) {
        badge.textContent = '-' + p.money(fsSaved);
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    item.classList.toggle('is-flash', !!res);

    var stockBox = item.querySelector('[data-p-flash-stock]');
    if (stockBox) {
      var info = stockInfo(section, item);
      if (info) {
        var txt = item.querySelector('[data-p-flash-stock-text]');
        var fill = item.querySelector('[data-p-flash-stock-fill]');
        if (txt) txt.textContent = info.text;
        if (fill) fill.style.width = info.percent + '%';
        stockBox.hidden = false;
      } else {
        stockBox.hidden = true;
      }
    }
  }

  function paintAll(section) {
    var collIds = [num(section, 'data-collection-id')];
    var items = section.querySelectorAll('[data-p-flash-item]');
    for (var i = 0; i < items.length; i++) paintItem(section, items[i], collIds);
  }

  function resetAll(section) {
    var items = section.querySelectorAll('[data-p-flash-item]');
    for (var i = 0; i < items.length; i++) items[i].classList.remove('is-flash');
  }

  /* ------------------------------------------------------------------ *
   * Đồng hồ + trạng thái
   * ------------------------------------------------------------------ */

  var _stops = [];

  function stopAll() {
    for (var i = 0; i < _stops.length; i++) {
      try { _stops[i](); } catch (e) {}
    }
    _stops.length = 0;
  }

  function paintTimer(section, target, label) {
    var p = P();
    var box = section.querySelector('[data-p-flash-timer]');
    if (!box || !p) return;

    var lbl = section.querySelector('[data-p-flash-timer-label]');
    if (lbl) lbl.textContent = label;
    box.hidden = false;

    var hh = section.querySelector('[data-p-flash-hh]');
    var mm = section.querySelector('[data-p-flash-mm]');
    var ss = section.querySelector('[data-p-flash-ss]');

    _stops.push(p.countdown(target, function (t) {
      // Không có ô "ngày" nữa -> dồn hết vào giờ (vd 26 giờ)
      if (hh) hh.textContent = pad2(t.hours + t.days * 24);
      if (mm) mm.textContent = pad2(t.minutes);
      if (ss) ss.textContent = pad2(t.seconds);
      if (t.done) setTimeout(refresh, 1200); // đóng đợt -> tính lại trạng thái
    }));
  }

  function refresh() {
    stopAll();

    var list = sections();
    for (var i = 0; i < list.length; i++) {
      var section = list[i];
      var sale = saleFor(section);

      resetAll(section);

      if (!sale) {
        section.hidden = true;
        continue;
      }

      if (sale.state === 'running') {
        section.hidden = false;
        section.classList.add('is-running');
        section.classList.remove('is-upcoming');
        paintAll(section);
        paintTimer(section, sale.endsAt, LABEL_RUNNING);
        continue;
      }

      if (sale.state === 'upcoming' && section.getAttribute('data-show-upcoming') === '1') {
        section.hidden = false;
        section.classList.add('is-upcoming');
        section.classList.remove('is-running');
        paintAll(section); // vẫn vẽ giá gốc + thanh còn hàng, chưa trừ FS
        paintTimer(section, sale.startsAt, LABEL_UPCOMING);
        continue;
      }

      section.hidden = true;
    }
  }

  function start() {
    if (!sections().length) return;

    if (window.PPromo) {
      window.PPromo.ready(refresh);
      window.PPromo.onChange(refresh);
      return;
    }

    // p-promo-core.js nạp defer — chờ bằng setTimeout, không dùng rAF.
    var tries = 40;
    (function wait() {
      if (window.PPromo) { start(); return; }
      if (tries-- <= 0) return;
      setTimeout(wait, 150);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
